import { TranslationKeys } from '../index'

export const enUS: TranslationKeys = {
  // Common
  common: {
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    remove: 'Remove',
    clear: 'Clear',
    reset: 'Reset',
    import: 'Import',
    export: 'Export',
    loading: 'Loading...',
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    info: 'Info',
    unknown: 'Unknown',
    zoom: 'Zoom',
    close: 'Close',
    ok: 'OK'
  },
  
  // Header
  header: {
    title: 'Markdown Table Editor',
    new: 'New',
    open: 'Open',
    save: 'Save',
    export: 'Export',
    undo: 'Undo',
    redo: 'Redo',
    settings: 'Settings',
    help: 'Help',
    shortcuts: 'Shortcuts Help',
    guide: 'User Guide',
    about: 'About',
    toggleSidebar: 'Toggle Sidebar (F11)',
    importFile: 'Import File (Ctrl+O)',
    exportFile: 'Export File',
    undoAction: 'Undo (Ctrl+Z)',
    redoAction: 'Redo (Ctrl+Shift+Z)',
    saveMarkdown: 'Save as Markdown (Ctrl+S)',
    settingsTooltip: 'Settings',
    helpTooltip: 'Help',
    shortcutsHelp: 'Keyboard Shortcuts',
    userGuide: 'User Guide',
    aboutApp: 'About This App',
    shortcutsNotImplemented: 'Shortcuts not implemented',
    guideNotImplemented: 'Guide not implemented',
    aboutNotImplemented: 'About not implemented'
  },
  
  // Sidebar
  sidebar: {
    files: 'Files',
    history: 'History',
    settings: 'Settings',
    style: 'Style',
    tableInfo: 'Table Info',
    rows: 'Rows',
    columns: 'Columns',
    cells: 'Cells',
    lastModified: 'Last Modified'
  },

  // Style Panel
  style: {
    backgroundColor: 'Background Color',
    textColor: 'Text Color',
    fontColor: 'Font Color',
    fontStyle: 'Font Style',
    fontSize: 'Font Size',
    padding: 'Padding',
    textStyle: 'Text Style',
    bold: 'Bold',
    italic: 'Italic',
    underline: 'Underline',
    alignment: 'Alignment',
    leftAlign: 'Left Align',
    centerAlign: 'Center Align',
    rightAlign: 'Right Align',
    borderStyle: 'Border Style',
    borderColor: 'Border Color',
    borderWidth: 'Border Width',
    borderType: 'Border Type',
    solid: 'Solid',
    dashed: 'Dashed',
    dotted: 'Dotted',
    double: 'Double',
    none: 'None',
    stylePreview: 'Style Preview',
    resetStyle: 'Reset Style',
    presetColors: 'Preset Colors',
    sampleText: 'Sample Text'
  },
  
  // Settings Panel
  settings: {
    appearance: 'Appearance',
    darkMode: 'Dark Mode',
    language: 'Language',
    fontSize: 'Font Size',
    editor: 'Editor Settings',
    autoSave: 'Auto Save',
    autoSaveInterval: 'Auto Save Interval (seconds)',
    showLineNumbers: 'Show Line Numbers',
    syntaxHighlight: 'Syntax Highlighting',
    wordWrap: 'Word Wrap',
    table: 'Table Settings',
    defaultAlignment: 'Default Alignment',
    showGridLines: 'Show Grid Lines',
    alternateRowColors: 'Alternate Row Colors',
    resizableColumns: 'Resizable Columns',
    maxHistorySize: 'Max History Size',
    importExport: 'Import/Export Settings',
    defaultExportFormat: 'Default Export Format',
    exportWithStyles: 'Export with Styles',
    compressExports: 'Compress Exports',
    performance: 'Performance Settings',
    enableVirtualScrolling: 'Enable Virtual Scrolling',
    lazyRendering: 'Lazy Rendering',
    renderDelay: 'Render Delay (ms)',
    management: 'Settings Management',
    saveSettings: 'Save Settings',
    loadSettings: 'Load Settings',
    exportSettings: 'Export Settings',
    importSettings: 'Import Settings',
    resetToDefault: 'Reset to Default',
    settingsSaved: 'Settings saved',
    settingsLoaded: 'Settings loaded',
    settingsReset: 'Settings reset',
    settingsExported: 'Settings exported',
    settingsImported: 'Settings imported',
    noSavedSettings: 'No saved settings',
    saveSettingsFailed: 'Failed to save settings',
    loadSettingsFailed: 'Failed to load settings',
    exportSettingsFailed: 'Failed to export settings',
    importSettingsFailed: 'Failed to import settings',
    checkFileFormat: 'Please check if the file format is correct'
  },
  
  // Editor Status
  editor: {
    unsavedChanges: 'Unsaved Changes',
    characterCount: 'Characters',
    lineCount: 'Lines',
    validTable: 'Valid Table'
  },

  // Table editing
  table: {
    addRow: 'Add Row',
    addColumn: 'Add Column',
    deleteRow: 'Delete Row',
    deleteColumn: 'Delete Column',
    alignLeft: 'Align Left',
    alignCenter: 'Align Center',
    alignRight: 'Align Right',
    copy: 'Copy',
    paste: 'Paste',
    cut: 'Cut',
    clear: 'Clear',
    merge: 'Merge Cells',
    split: 'Split Cells',
    parseError: 'Table parsing failed',
    unknownError: 'Unknown error',
    edit: 'Edit',
    preview: 'Preview',
    line: 'Line',
    applyChanges: 'Apply Changes',
    reset: 'Reset',
    copyContent: 'Copy Content',
    downloadMarkdown: 'Download Markdown',
    placeholder: 'Enter Markdown table content here...'
  },
  
  // View modes
  view: {
    table: 'Table View',
    markdown: 'Markdown View',
    preview: 'Preview Mode',
    split: 'Split Mode',
    tableEditor: 'Table Editor',
    markdownEditor: 'Markdown Editor',
    previewPane: 'Preview',
    markdownPreview: 'Markdown',
    htmlPreview: 'HTML'
  },
  
  // Export Formats
  export: {
    markdown: 'Markdown',
    csv: 'CSV',
    excel: 'Excel',
    html: 'HTML',
    json: 'JSON',
    png: 'PNG Image',
    svg: 'SVG Vector',
    exportSuccess: 'Export successful',
    exportError: 'Export failed',
    unsupportedFormat: 'Unsupported format'
  },
  
  // History
  history: {
    undo: 'Undo',
    redo: 'Redo',
    undoSuccess: 'Undo successful',
    redoSuccess: 'Redo successful',
    noUndoOperations: 'No operations to undo',
    noRedoOperations: 'No operations to redo',
    clearHistory: 'Clear History',
    historyManaged: 'History managed'
  },
  
  // File Management
  files: {
    newFile: 'New File',
    fileName: 'File Name',
    fileDescription: 'File Description',
    createFile: 'Create File',
    deleteFile: 'Delete File',
    renameFile: 'Rename File',
    duplicateFile: 'Duplicate File',
    fileCreated: 'File created',
    fileDeleted: 'File deleted',
    fileRenamed: 'File renamed',
    fileDuplicated: 'File duplicated',
    search: 'Search Files',
    noFiles: 'No files',
    preview: 'Preview',
    save: 'Save',
    searchPlaceholder: 'Search files...',
    importFile: 'Import File',
    uploadHint: 'Click or drag file to this area to upload',
    supportedFormats: 'Support .md, .csv, .xlsx, .json formats',
    fileList: 'File List',
    current: 'Current',
    copy: 'Copy',
    export: 'Export',
    deleteConfirm: 'Are you sure to delete this file?',
    ok: 'OK',
    cancel: 'Cancel',
    close: 'Close',
    openFile: 'Open File',
    fileSize: 'File Size',
    createTime: 'Created',
    modifyTime: 'Modified',
    tableSize: 'Table Size',
    markdownPreview: 'Markdown Preview',
    rows: 'rows',
    columns: 'columns',
    enterFileName: 'Enter file name',
    pleaseEnterFileName: 'Please enter file name',
    fileCreatedSuccess: 'File created',
    fileOpenedSuccess: 'File opened',
    noOpenFile: 'No open file',
    fileNotExist: 'File does not exist',
    fileSavedSuccess: 'File saved',
    fileDeletedSuccess: 'File deleted',
    fileCopiedSuccess: 'File copied',
    exportSuccess: 'File exported',
    exportFailed: 'Export failed',
    importSuccess: 'File imported',
    importFailed: 'Import failed',
    importError: 'Error occurred while importing file',
    noMatchingFiles: 'No matching files found',
    clickOrDragToUpload: 'Click or drag file to this area to upload'
  },

  // Shortcuts Modal
  shortcuts: {
    title: 'Keyboard Shortcuts',
    subtitle: 'Master these shortcuts to boost your productivity',
    fileOperations: 'File Operations',
    editing: 'Editing',
    navigation: 'Navigation',
    selectionCopyPaste: 'Selection & Copy/Paste',
    tableStructure: 'Table Structure',
    formatting: 'Formatting',
    interface: 'Interface',
    view: 'View',
    openImportFile: 'Open/Import file',
    saveAsMarkdown: 'Save as Markdown',
    exportMenu: 'Export menu',
    newTable: 'New table',
    undoLastAction: 'Undo last action',
    redoLastAction: 'Redo last action',
    redoAlternative: 'Redo (alternative)',
    clearSelectedCells: 'Clear selected cells',
    clearCellAndStartEditing: 'Clear cell and start editing',
    moveToNextCell: 'Move to next cell',
    moveToPreviousCell: 'Move to previous cell',
    moveToCellBelow: 'Move to cell below',
    moveToCellAbove: 'Move to cell above',
    navigateWithArrowKeys: 'Navigate with arrow keys',
    goToFirstCellInRow: 'Go to first cell in row',
    goToLastCellInRow: 'Go to last cell in row',
    selectAllCells: 'Select all cells',
    multiSelectCells: 'Multi-select cells',
    rangeSelectCells: 'Range select cells',
    copySelectedCells: 'Copy selected cells',
    pasteFromClipboard: 'Paste from clipboard',
    cutSelectedCells: 'Cut selected cells',
    addRowAbove: 'Add row above',
    addRowBelow: 'Add row below',
    addColumnLeft: 'Add column left',
    addColumnRight: 'Add column right',
    deleteSelectedRow: 'Delete selected row',
    deleteSelectedColumn: 'Delete selected column',
    toggleBold: 'Toggle bold',
    toggleItalic: 'Toggle italic',
    toggleUnderline: 'Toggle underline',
    alignLeft: 'Align left',
    alignCenter: 'Align center',
    alignRight: 'Align right',
    toggleSidebar: 'Toggle sidebar',
    openSettings: 'Open settings',
    showHelp: 'Show help',
    showShortcuts: 'Show shortcuts',
    closeModalsOrCancelEditing: 'Close modals/cancel editing',
    tableView: 'Table view',
    markdownView: 'Markdown view',
    previewView: 'Preview view',
    splitView: 'Split view',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    resetZoom: 'Reset zoom'
  },

  // About Modal
  about: {
    title: 'Markdown Table Editor',
    subtitle: 'A powerful visual Markdown table editing application',
    version: 'Version',
    features: 'Key Features',
    visualTableEditing: 'Visual table editing with drag-and-drop support',
    realtimeMarkdownSync: 'Real-time Markdown synchronization',
    multipleImportExportFormats: 'Multiple import/export formats',
    richStylingOptions: 'Rich styling and formatting options',
    keyboardShortcutsSupport: 'Keyboard shortcuts support',
    undoRedoFunctionality: 'Undo/Redo functionality',
    multiLanguageSupport: 'Multi-language support',
    darkLightTheme: 'Dark/Light theme',
    supportedFormats: 'Supported Formats',
    importFormats: 'Import',
    exportFormats: 'Export',
    keyboardShortcuts: 'Quick Shortcuts',
    openFile: 'Open file',
    saveFile: 'Save as Markdown',
    undo: 'Undo',
    redo: 'Redo',
    toggleSidebar: 'Toggle sidebar',
    navigateCells: 'Navigate cells',
    madeWith: 'Made with',
    byTheCommunity: 'by the community',
    openSource: 'Open source',
    mitLicense: 'MIT License',
    builtWith: 'Built with React and Ant Design',
    viewOnGithub: 'View on GitHub',
    view: {
      title: 'View',
      zoomIn: 'Zoom In',
      zoomOut: 'Zoom Out',
      resetZoom: 'Reset Zoom',
      toggleTheme: 'Toggle Theme'
    },
    proTips: 'Pro Tips',
    tip1: 'Hold',
    tip1Suffix: 'while using arrow keys to select ranges',
    tip2: 'Use',
    tip2Suffix: 'to select multiple non-adjacent cells',
    tip3: 'Double-click any cell to quickly start editing',
    tip4: 'Drag column borders to visually adjust column width'
  }
}